import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    margin: "0 auto",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    minHeight: "10em",
  },
  signupMessageContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(2),
    textAlign: "center",
  },
  placeholder: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(2, 4),
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
  placeholderText: {
    fontSize: "1.5rem",
    fontWeight: 500,
  },
  histogramContainer: {
    marginTop: theme.spacing(4),
  },
}));
